<template>
  <Modal
    cancelText="cancel"
    :enableMainAction="!!selectedRecipientEmail"
    :handleMainAction="handleMainAction"
    headerText="Send Users Email"
    mainActionText="yes"
    :showClose="true"
    :visible="visible"
    @updateVisibility="handleClose"
  >
    <div :class="$style.bulkResendActivationEmailModal">
      <UserSecurityStatusList
        :class="$style.userList"
        :selectedUsers="selectedUsers"
      >
        <span :class="$style.formBody">
          Please choose a destination option below.
        </span>
      </UserSecurityStatusList>
      <form :class="$style.form">
        <div
          v-for="(
            recipientEmailOption, index
          ) in $options.recipientEmailOptions"
          :key="index"
          :class="$style.radioBtnContainer"
        >
          <input
            :id="`bulkResendActivationEmail-radiuBtn-${index}`"
            v-model="selectedRecipientEmail"
            :class="$style.radioBtn"
            name="sendEmailToAlternateEmail"
            type="radio"
            :value="recipientEmailOption.value"
          >
          <label
            :class="$style.radioBtnLabel"
            :for="`bulkResendActivationEmail-radiuBtn-${index}`"
          >
            {{ recipientEmailOption.label }}
            <p
              v-if="recipientEmailOption.hint"
              :class="$style.radioBtnHint"
            >
              {{ recipientEmailOption.hint }}
            </p>
          </label>
        </div>
      </form>

      <p data-test-id="footerDisclaimer">
        {{ footerDisclaimerText }}
      </p>
    </div>
  </Modal>
</template>

<script>
import { RecipientEmailConst } from 'client/util/Constants';
import BulkResendEmailMixin from 'client/systemusers/BulkResendEmail/BulkResendEmailMixin';
import Modal from 'client/components/Modal/Modal.vue';
import UserSecurityStatusList from 'client/systemusers/BulkResendEmail/UserSecurityStatusList.vue';
import pluralize from 'pluralize';

export default {
  name: 'BulkResendActivationEmailModal',
  components: { Modal, UserSecurityStatusList },
  mixins: [BulkResendEmailMixin],
  recipientEmailOptions: [
    {
      hint: 'If the user doesn’t have an alternate email, it will automatically be sent to their company email',
      label: 'Send activation email to alternate email',
      value: RecipientEmailConst.ALTERNATE,
    },
    {
      label: 'Send activation email to company email',
      value: RecipientEmailConst.PRIMARY,
    },
  ],
  data() {
    return {
      selectedRecipientEmail: '',
    };
  },
  computed: {
    footerDisclaimerText() {
      return `Emails will only be sent to users who have an Active user state.
      Are you sure you would like to send
      ${pluralize('email', this.selectedUsers.length)} to the selected 
      ${pluralize('user', this.selectedUsers.length)}?`;
    },
  },
  watch: {
    visible() {
      this.selectedRecipientEmail = '';
    },
  },
  methods: {
    emitContinue() {
      this.$emit('continue', this.selectedRecipientEmail);
    },
  },
};
</script>

<style module>
@value (jcGrey600, jcGrey) from '~css/brand-colors.css';

.bodyMessage {
  margin: 0 0 25px;
}

.bulkResendActivationEmailModal {
  line-height: 1.19;
}

.bulkResendActivationEmailModal .disclaimerMessage {
  font-size: 0.923rem;
  line-height: 1.67;
}

.form {
  margin: 0 0 40px;
}

.radioBtn {
  cursor: pointer;
  margin-right: 8px;
  margin-top: 2px;
}

.radioBtnContainer {
  cursor: pointer;
  display: flex;
}

.radioBtnContainer:not(:last-child) {
  margin-bottom: 16px;
}

.radioBtnHint {
  color: jcGrey;
  font-size: 0.923rem;
  margin: 4px 0 0;
}

.radioBtnLabel {
  color: jcGrey600;
  cursor: pointer;
}

.userList {
  margin: 0 0 8px;
}

.userList li:last-of-type {
  display: inline-block;
}

.formBody {
  display: inline;
}
</style>
